module.exports = __webpack_public_path__ + "img/LogoVec.b68a5884.svg";